import { Box, Skeleton, Tab, Tabs, Theme } from "@outschool/backpack";
import React from "react";

import {
  EDUCATOR_TOOLBAR_SKELETON,
  TEACHER_DASHBOARD_SKELETON_GEOMETRY,
} from "../../../shared/TeacherDashboardSkeletonGeometry";
import HeaderLogo from "../nav/HeaderLogo";
import TeacherDashboardSkeleton from "../teacher/TeacherDashboardSkeleton";

const { header } = TEACHER_DASHBOARD_SKELETON_GEOMETRY;

function EducatorHeaderSkeleton() {
  return (
    <Box
      data-test-id="educator-header-skeleton"
      sx={{
        backgroundColor: "common.white",
        height: `${header.height}px`,
        overflow: "hidden",
      }}
    >
      <Box
        flex
        sx={(theme: Theme) => ({
          alignItems: "center",
          boxSizing: "border-box",
          gap: `${header.gap}px`,
          height: `${header.height}px`,
          justifyContent: "center",
          marginX: "auto",
          maxWidth: `${header.maxWidth}px`,
          width: `calc(100% - ${header.horizontalMargin * 2}px)`,
          [theme.breakpoints.down("md")]: {
            justifyContent: "space-between",
          },
          [theme.breakpoints.between("md", "lg")]: {
            gap: "16px",
          },
        })}
      >
        <Box sx={{ display: "flex", flexShrink: 0 }}>
          <HeaderLogo />
        </Box>

        <Tabs
          data-test-id="educator-toolbar-skeleton"
          aria-busy={true}
          value={false}
          variant="scrollable"
          sx={(theme: Theme) => ({
            flex: 1,
            minWidth: 0,
            [theme.breakpoints.down("md")]: {
              display: "none",
            },
          })}
        >
          {EDUCATOR_TOOLBAR_SKELETON.tabLabelWidths.map(width => (
            <Tab
              key={width}
              disabled
              label={<Skeleton variant="text" width={width} height={28} />}
            />
          ))}
        </Tabs>

        <Box flex sx={{ alignItems: "center", flexShrink: 0, gap: 16 }}>
          <Skeleton
            variant="text"
            width={112}
            height={32}
            sx={(theme: Theme) => ({
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
            })}
          />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>
      </Box>
    </Box>
  );
}

export default function EducatorAppShellSkeleton() {
  return (
    <Box aria-busy={true}>
      <EducatorHeaderSkeleton />
      <TeacherDashboardSkeleton />
    </Box>
  );
}
